import { v2 } from '@saucelabs/sl-module-builds';

import { NAMESPACE } from './types';

const reducer = v2.buildsList.reducers.createVDCReducer(NAMESPACE);
export default reducer;
